/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251226
*/
'use strict';

import {
    getPromise,
    savePromise
} from './ctssJQuery.js';
import {
    isDataModified,
    setModified
} from './ctssVal.js';
import {
    getAppToken,
    setMenu
} from './snSite.js';

const token = getAppToken();

const buildEnableGroupCheckBox = (params) => {
    return '<div class="pLeft10 mBottom5">' +
        `<input id='cbEnableGroup${params.feature}' type='checkbox' class='k-checkbox' ${params.checked}/>` +
        `<label for='cbEnableGroup${params.feature}' class='k-checkbox-label'>${params.feature}</label>` +
        '</div>';
}

const saveSettingsAsync = async (params) => {

    await savePromise({
        url: `ChurchSettings/${token.CG}`,
        data: {
            joinChurchWithCodeOnly: $('#cbJoinChurchWithCodeOnly').is(':checked'),
            approvePrayerRequest: $('#cbApprovePrayerRequest').is(':checked'),
            overrideProfanityOnPrayerRequest: $('#cbOverrideProfanityOnPrayerRequest').is(':checked'),
            hasPrayerComments: $('#cbHasPrayerComments').is(':checked'),
            overrideProfanityOnAnnouncement: $('#cbOverrideProfanityOnAnnouncement').is(':checked'),
            hasAnnouncementComments: $('#cbHasAnnouncementComments').is(':checked'),
            groupJoinRequestInterval: $('#editGroupJoinRequestInterval').val(),
            enableGroupAnnouncements: $('#cbEnableGroupAnnouncements').is(':checked'),
            enableGroupEvents: $('#cbEnableGroupEvents').is(':checked'),
            enableGroupPrayers: $('#cbEnableGroupPrayers').is(':checked'),
            groupLeadersApprovePrayers: $('#cbGroupLeadersApprovePrayers').is(':checked'),
            enableGroupSermons: $('#cbEnableGroupSermons').is(':checked')
        }
    }).then(() => {
        setModified(false);
    });
}

const getSettingsAsync = async () =>
    await getPromise({ url: `ChurchSettings/${token.CG}` });

const initAsync = async () => {

    document.getElementById("loader").style.display = "none";
    window.onbeforeunload = () => {
        if (isDataModified() === true) {
            return "Your changes have not been saved...";
        }
    };

    setMenu();

    try {
        const data = await getSettingsAsync();

        $("#cbJoinChurchWithCodeOnly").prop('checked', data.joinChurchWithCodeOnly);
        $("#cbApprovePrayerRequest").prop('checked', data.approvePrayerRequest);
        $("#cbOverrideProfanityOnPrayerRequest").prop('checked', data.overrideProfanityOnPrayerRequest);
        $("#cbHasPrayerComments").prop('checked', data.hasPrayerComments);
        $("#cbOverrideProfanityOnAnnouncement").prop('checked', data.overrideProfanityOnAnnouncement);
        $("#cbHasAnnouncementComments").prop('checked', data.hasAnnouncementComments);

        let content = '';
        if (data.hasAnnouncementsFeature) {
            content += buildEnableGroupCheckBox({
                feature: 'Announcements',
                checked: data.enableGroupAnnouncements ? 'checked' : ''
            });
        }
        if (data.hasEventsFeature) {
            content += buildEnableGroupCheckBox({
                feature: 'Events',
                checked: data.enableGroupEvents ? 'checked' : ''
            });
        }
        if (data.hasPrayersFeature) {
            content += buildEnableGroupCheckBox({
                feature: 'Prayers',
                checked: data.enableGroupPrayers ? 'checked' : ''
            });
            content += '<div class="pLeft35 mBottom5">' +
                `<input id='cbGroupLeadersApprovePrayers' type='checkbox' class='k-checkbox' ${data.groupLeadersApprovePrayers ? 'checked' : ''}/>` +
                `<label for='cbGroupLeadersApprovePrayers' class='k-checkbox-label'>Group Leaders Approve Prayers</label>` +
                '</div>';
        }
        if (data.hasSermonsFeature) {
            content += buildEnableGroupCheckBox({
                feature: 'Sermons',
                checked: data.enableGroupSermons ? 'checked' : ''
            });
        }
        $('#divGroupFeatures').empty().append(content);

        $('#editGroupJoinRequestInterval').val(data.groupJoinRequestInterval);

    }
    catch (error) { }

    $('#btnSave').on('click', async () => await saveSettingsAsync({ btnId: '#btnSave' }))
}


export {
    getSettingsAsync
};

window.snSettings = {
    initAsync
};
